import RefereeRefalignPay from "../../components/placeholder/RefereeRefalignPay";
import RefereeReportGames from "../../components/RefereeReportGames";
import RefereeAnnouncements from "../../components/RefereeAnnouncements";
import RefereeAssignedGames from "../../components/RefereeAssignedGames";
import ModernShell from "../../components/ModernShell";
import RefereeUpcomingGames from "../../components/RefereeUpcomingGames";
import ReportGameModal from "../../components/Modals/ReportGameModal";
import React, { useState, useEffect } from "react";
import { useAppContext } from "../../context/MainContext/AppContext";
import {
  filterPendingGames,
  filterUpcomingGames,
  filterReportGames,
} from "../../utils/filterGamesData";

const RefereeOverview = () => {
  const { alterPosition, database_user, RefereeGameData } =
    useAppContext();
  const [isReportGameModalOpen, setIsReportGameModalOpen] = useState(false);
  const [reportGameData, setReportGameData] = useState(null);
  const [reportGameReferees, setReportGameReferees] = useState(null);
  const UID = database_user.UID;

  const [filteredPendingGames, setFilteredPendingGames] = useState(null);
  const [filteredUpcomingGames, setFilteredUpcomingGames] = useState(null);
  const [filteredReportGames, setFilteredReportGames] = useState(null);

  useEffect(() => {
    if (RefereeGameData && UID) {
      setFilteredPendingGames(filterPendingGames(RefereeGameData, UID));
      setFilteredUpcomingGames(filterUpcomingGames(RefereeGameData, UID));
      setFilteredReportGames(filterReportGames(RefereeGameData, UID));
    }
  }, [RefereeGameData, UID]);

  const handleButtonClick = {
    handleReportGames: (data) => {
      setReportGameData(data);

      const positionsArray = Object.entries(data.gameData.Positions).map(
        ([id, positionData]) => {
          return { id, ...positionData };
        }
      );

      setReportGameReferees(positionsArray);
      setIsReportGameModalOpen(true);
    },

    handleAssignedGames: (data) => {
      console.log(data);
      alterPosition(data);
    },

    handleUpcomingGames: (data) => {
      alterPosition(data);
      // alert("Error, please reach out to your assigner to turnback this game!");
    },

    handleSubmitReportGameModal: (data) => {
      alterPosition(data);
      console.log(data);
      setIsReportGameModalOpen(false);
    },
  };

  useEffect(() => {
  }, []);

  return (
    <ModernShell title="Referee overview" subtitle="Your games, alerts, and payouts in one place.">
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
        <div className="xl:col-span-3">
          <RefereeRefalignPay />
        </div>
        <div className="xl:col-span-5">
          <RefereeReportGames
            apidata={filteredReportGames}
            handleButtonClick={handleButtonClick}
            UID={UID}
          />
        </div>
        <div className="xl:col-span-4">
          <RefereeAnnouncements />
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 xl:grid-cols-2 gap-4">
        <RefereeAssignedGames
          pendingGames={filteredPendingGames}
          UID={UID}
          handleButtonClick={handleButtonClick}
        />
        <RefereeUpcomingGames
          upcomingGames={filteredUpcomingGames}
          UID={UID}
          handleButtonClick={handleButtonClick}
        />
      </div>

      <ReportGameModal
        isOpen={isReportGameModalOpen}
        onClose={() => setIsReportGameModalOpen(false)}
        handleButtonClick={handleButtonClick}
        reportGameData={reportGameData}
        reportGameReferees={reportGameReferees}
      />
    </ModernShell>
  );
};

export default RefereeOverview;
